import { render, staticRenderFns } from "./ChatMessageDeleteModal.vue?vue&type=template&id=426591ba&"
import script from "./ChatMessageDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports